<template>
  <div class="home-banner">
    <!-- 左侧分类导航 -->
    <div class="category-nav">
      <ul>
        <li class="category-nav_item" v-for="(item, index) in categories" :key="index"
          @mouseenter="showSubCategory(item)" @mouseleave="isExpanded = false" @click="jumpCategory(item)">
          <img class="imgS_14" :src="item.classifyImage" alt />
          <span class="selectedSpan">{{ item.classifyName }}</span>
        </li>
      </ul>
      <!-- 右侧多级分类面板 -->
      <div class="subcategory-panel" v-show="isExpanded" @mouseenter="isExpanded = true"
        @mouseleave="isExpanded = false">
        <!-- 二级分类 -->
        <ul class="secondary-category-list">
          <li v-for="sub in currentCategory.childs" :key="sub.classifyId" class="secondary-category-item">
            <div class="flex flex_a_fs">
              <div class="secondary-category-list-title ell cursor_p" :title="sub.classifyName"
                @click="jumpCategory(sub)">
                <span class="selectedSpan display_ib fontS_12">{{ sub.classifyName }}</span>
              </div>
              <i class="el-icon-arrow-right mr_16 ml_8"></i>
              <div class="flex flex_w gap_10">
                <div class="color_666 cursor_p" v-for="(subSub, subSubk) in sub.childs" :key="subSubk"
                  @click="jumpCategory(subSub)">
                  <span class="selectedSpan fontS_12">{{ subSub.classifyName }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 顶部横幅广告 -->
      <div class="top-banner">
        <div class="banner-left">
          <el-carousel trigger="click" height="193px">
            <el-carousel-item v-for="(item, k) in bannerList" :key="k" @click.native="handlerImg(item)" class="cur_p">
              <img style="width: 100%;height: 100%;object-fit: cover;" :src="item.bannerUrl" alt="促销活动" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="banner-right" style="padding: 0;">
          <!-- <div class="sub-banner">
                        <div class="mb_8 flex_j_sb">
                            <div class="Ltitle">国家补贴 x 百亿补贴</div>
                            <div class="Rtitle">官方限时补</div>
                        </div>
                        <div class="products">
                            <div class="product-item">
                                <img src="@/assets/images/banner2.png" alt="手机">
                                <div class="price">¥4999</div>
                                <div class="discount">已补500元</div>
                            </div>
                            <div class="product-item">
                                <img src="@/assets/images/home/home1.png" alt="笔记本">
                                <div class="price">¥2999</div>
                                <div class="discount">已补300元</div>
                            </div>
                            <div class="product-item">
                                <img src="@/assets/images/home/home2.png" alt="电动车">
                                <div class="price">¥1999</div>
                                <div class="discount">已补300元</div>
                            </div>
                            <div class="product-item">
                                <img src="@/assets/images/home/home7.png" alt="相机">
                                <div class="price">¥669</div>
                                <div class="discount">已补199元</div>
                            </div>
                            <div class="product-item">
                                <img src="@/assets/images/home/home3.png" alt="电饭煲">
                                <div class="price">¥299</div>
                                <div class="discount">已补99元</div>
                            </div>
                        </div>
          </div>-->
          <div class="live-streaming cur_p" @click="toLiveStreamingRoom('/liveStreamingRoom', '')">
            <div class="mb_12 flex">
              <div class="title">有有上新</div>
              <img src="@/assets/images/hot.png" style="width:56px;height:23px;" />
              <!-- <div class="subtitle">直播享好价</div> -->
            </div>
            <div class="live-cards">
              <div class="live-card" v-for="(item, index) in newProductlist" :key="index">
                <img :src="item.image" />
                <!-- <div v-if="index==0" style="margin-top:15px"></div> -->
                <div>¥{{ item.originalPrice }}</div>
                <!-- <div v-else>¥9.9</div> -->

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间推荐区域 -->
      <div class="recommend-section">
        <!-- <div class="live-streaming cur_p" @click="toLiveStreamingRoom()">
                    <div class="flex_j_sb mb_12">
                        <div class="title">有有宝直播</div>
                        <div class="subtitle">直播享好价</div>
                    </div>
                    <div class="live-cards">
                        <div class="live-card">
                            <img src="@/assets/images/liveStreamingRoom/liveStreamingRoom1.png" alt="直播1">
                            <div class="card-title">个护洗漱店</div>
                        </div>
                        <div class="live-card">
                            <img src="@/assets/images/liveStreamingRoom/liveStreamingRoom3.png" alt="直播2">
                            <div class="card-title">零食百货店</div>
                        </div>
                        <div class="live-card">
                            <img src="@/assets/images/liveStreamingRoom/liveStreamingRoom5.png" alt="直播3">
                            <div class="card-title">国货个护店</div>
                        </div>
                    </div>
        </div>-->

        <!-- <div class="flash-sale">
                    <div class="flex_j_sb mb_12">
                        <div class="title">有有宝秒杀</div>
                        <div class="subtitle">限时秒杀</div>
                    </div>
                    <div class="sale-items">
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/4e95b71dec24457c85ba29683794c39658ec93f5c3639062.jpg" alt="">
                            <div class="price">¥56</div>
                        </div>
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/3f953cbb48464c249c337a9566b10f09c3f1b5b02462cdd4.jpg" alt="">
                            <div class="price">¥106</div>
                        </div>
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/8000b3fc29e640318e6b9060e02176c008e41473e0596122.jpg" alt="">
                            <div class="price">¥68</div>
                        </div>
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/39b4ef8d83694a628e74f65d299fef0e639667c42407db38.jpg" alt="">
                            <div class="price">¥183.8</div>
                        </div>
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/44ebb9be9f7d4c599e4013ffd6fa5f040401e999911980b9.jpg" alt="">
                            <div class="price">¥80</div>
                        </div>
                        <div class="sale-item">
                            <img style="border-radius: 6px;" src="https://zk-cereshop.oss-cn-shenzhen.aliyuncs.com/test/2021-12-03/ae2a7c901b8e4129958cd4139361e6fd15.jpg" alt="">
                            <div class="price">¥68.96</div>
                        </div>
                    </div>
        </div>-->
        <div class="package-deals cur_p" @click="toLiveStreamingRoom('/information', '')">
          <div class="flex_j_sb mb_12">
            <div class="title">有有资讯</div>
            <!-- <div class="subtitle">1元也包邮</div> -->
          </div>
          <div class="information">
            <ol class="flex_d_c ">
              <li class="flex_j_sb mb_8" v-for="(item, index) in informationList.slice(0, 2)" :key="index">
                <img class="mr_8 informationImg" :src="item.images">
                <span class="ell-multi">{{ item.title }}</span>
              </li>

            </ol>
          </div>
        </div>

        <div class="package-deals cur_p" @click="toLiveStreamingRoom('/specialOffer', '', '')">
          <div class="flex_j_sb mb_12">
            <div class="title">有有特价</div>
            <!-- <div class="subtitle">1元也包邮</div> -->
          </div>
          <div class="items">
            <div class="deal-item" v-for="(item, index) in specialOfferlist" :key="index">
              <img :src="item.image" />
              <div class="price">¥{{ item.originalPrice }}</div>
              <!-- <div class="price">¥29.9</div> -->
            </div>

          </div>
        </div>
        <div class="package-deals cur_p" @click="toLiveStreamingRoom('/costume', costumeClassifyId)">
          <div class="flex_j_sb mb_12">
            <div class="title">服饰配饰</div>
            <!-- <div class="subtitle">1元也包邮</div> -->
          </div>
          <div class="items">
            <div class="deal-item" v-for="(item, index) in costumelist" :key="index">
              <img :src="item.image" />
              <div class="price">¥{{ item.originalPrice }}</div>
              <!-- <div class="price">¥45.9</div> -->
            </div>

          </div>
        </div>
        <div class="package-deals cur_p" @click="toLiveStreamingRoom('/foodZone', foodClassifyId)">
          <div class="flex_j_sb mb_12">
            <div class="title">食品茶酒</div>
            <!-- <div class="subtitle">1元也包邮</div> -->
          </div>
          <div class="items">
            <div class="deal-item" v-for="(item, index) in foodList.slice(0, 2)" :key="index">
              <img :src="item.image" />
              <div class="price">¥{{ item.originalPrice }}</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 右侧登录区 -->
    <div>
      <div v-if="!isUserLoggedIn" class="flex_d_c gap_16">
        <div class="user-login">
          <div class="avatar">
            <i class="el-icon-user"></i>
          </div>
          <div class="greeting">Hi ~ 下午好</div>
          <div class="login-text">登录有有宝 发现更多精彩</div>
          <button class="login-btn" @click="loginBtn">立即登录</button>
        </div>
        <div class="you-you-shi mb_12" >
          <div class="title">品牌店铺</div>

          <ul>
            <li v-for="(item, index) in shopList" :key="index" @click="toStore(item.shopId)" class="cur_p">
              <img :src="item.shopLogo" alt="店铺" />
            </li>
           
          </ul>
        </div>
      </div>
      <div v-else>
        <div class="user-center">
          <!-- 用户头像和信息 -->
          <div class="user-header">
            <div class="user-avatar">
              <img :src="userInfo.headImage || defaultAvatar" alt />
            </div>
            <div class="user-info">
              <div class="user-name ell" :title="userInfo.name">{{ userInfo.name }}</div>
              <div class="user-actions">
                <span class="cur_p" @click="loginBtn">切换账号</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cur_p" @click="outLoginBtn">退出</span>
              </div>
            </div>
            <div class="ai-badge">
              <img src="@/assets/images/Icon/Group2.png" alt @click="toMyDistribution" />
            </div>
          </div>

          <!-- 账户余额 -->
          <div class="user-balance">
            <div class="balance-item">
              <div class="balance-number">{{ userInfo.couponCount || '-' }}</div>
              <div class="balance-label">优惠券</div>
            </div>
            <div class="balance-item">
              <div class="balance-number">{{ userInfo.amountMoney || '-' }}</div>
              <div class="balance-label">余额</div>
            </div>
            <div class="balance-item">
              <div class="balance-number">{{ userInfo.youCoin || '-' }}</div>
              <div class="balance-label">有有币</div>
            </div>
          </div>

          <!-- 快捷入口 -->
          <div class="quick-actions">
            <div class="action-item" @click="toRouter({ path: '/myOrder', query: { activeName: 1 } })">
              <el-badge :value="userInfo.waitPayOrderCount" :hidden="!userInfo.waitPayOrderCount" class="item">
                <img src="@/assets/images/Icon/PengdingpaymentOutlined.png" alt />
                <div class="action-text">待付款</div>
              </el-badge>
            </div>
            <div class="action-item" @click="toRouter({ path: '/myOrder', query: { activeName: 3 } })">
              <el-badge :value="userInfo.waitReceiveOrderCount" :hidden="!userInfo.waitReceiveOrderCount" class="item">
                <img src="@/assets/images/Icon/PengdingreceivedOutlined.png" alt />
                <div class="action-text">待收货</div>
              </el-badge>
            </div>
            <div class="action-item" @click="toRouter({ path: '/myOrder', query: { activeName: 4 } })">
              <el-badge :value="userInfo.waitCommentOrderCount" :hidden="!userInfo.waitCommentOrderCount" class="item">
                <img src="@/assets/images/Icon/PendingreviewedOutlined.png" alt />
                <div class="action-text">待评价</div>
              </el-badge>
            </div>
            <div class="action-item" @click="toRouter({ path: '/orderAfterSale' })">
              <el-badge :value="userInfo.afterCount" :hidden="!userInfo.afterCount" class="item">
                <img src="@/assets/images/Icon/AftersalesOutlined.png" alt />
                <div class="action-text">退货售后</div>
              </el-badge>
            </div>
          </div>
          <!-- 订单状态 -->
          <div class="order-status mb_20">
            <div v-if="shoppingCart.length == 0">
              <div class="order-item">
                <div class="order-image">
                  <img src="@/assets/images/Icon/NoData.png" alt="商品图片" />
                </div>
                <div class="order-content">
                  <div class="order-title">暂无订单信息</div>
                  <div class="order-desc">下单后查看更多订单信息</div>
                </div>
              </div>
            </div>
            <div v-else>
              <el-carousel arrow="never" indicator-position="outside" class="order-status_carousel" height="45px">
                <el-carousel-item v-for="(item, key) in shoppingCart" :key="key">
                  <div class="order-item" @click="toRouter({ path: '/myOrder', query: { activeName: 0 } })">
                    <div class="order-image">
                      <img :src="item.skus[0].image" alt="商品图片" />
                    </div>
                    <div class="order-content">
                      <div class="order-title">{{ item.state | orderStatus }}</div>
                      <div class="order-desc">您的订单{{ item.state | orderStatus }}...</div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>

          <!-- 底部链接 -->
          <div class="footer-links">
            <div class="footer-link" @click="toRouter('/browseRecords')">
              <img src="@/assets/images/Icon/Browsinghistory .png" alt />
              <span>浏览记录</span>
            </div>
            <div class="footer-link" @click="toRouter({ path: '/favorites', query: { activeName: 'commodity' } })">
              <img src="@/assets/images/Icon/Productcollection.png" alt />
              <span>商品收藏</span>
            </div>
            <div class="footer-link" @click="toRouter({ path: '/favorites', query: { activeName: 'shop' } })">
              <img src="@/assets/images/Icon/Storefollowings.png" alt />
              <span>店铺收藏</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="outLoginDialog" width="30%">
      <span>确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer flex_j_d">
        <el-button @click="outLoginDialog = false">取 消</el-button>
        <el-button type="primary" @click="outLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { orderMixin } from '@/mixins/orderMixin'

import defaultAvatar from '@/assets/images/defaultAvatar.png'
import Cookie from 'js-cookie'
import {
  getCategory
} from '@/api/nav.js'
import {
  getCanvas, gethotProducts
} from '@/components/canvasShow/config/api'
import {
  getOrderList,
} from '@/api/user/order.js'
import {
  getClaasifyProducts,
  getConsultation,
  getIndexShop
} from '@/api/product.js'

export default {
  name: 'HomeBanner',
  mixins: [orderMixin],

  data () {
    return {
      categories: [
      ],
      currentCategory: [],
      defaultAvatar: defaultAvatar,
      outLoginDialog: false,
      shoppingCart: [],
      isExpanded: false,
      componentContent: [],
      bannerList: [],
      isUserLoggedIn: false,
      costumelist: [], // 服饰配饰
      costumeClassifyId: '794', // 服饰配饰的id
      specialOfferlist: [], // 有有特价
      foodClassifyId: '773', // 食品茶酒
      foodList: [], // 食品茶酒
      newProductlist: [], // 新品上市
      informationList: [], // 有有资讯
      livingHome: '1512', // 居家
      shopList:[],//店铺
    }
  },
  filters: {
    orderStatus (status) {
      const statusMap = {
        1: '待付款',
        2: '等待发货',
        3: '等待收货',
        4: '已完成',
        5: '已关闭'
      }
      return statusMap[status] || '未知状态'
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    // isUserLoggedIn () {
    //     return this.$store.state.isLogin // 假设 store 中有这个状态
    // }

  },
  watch: {
    '$store.state.isLogin': {
      handler (nVal, oVal) {
        this.isUserLoggedIn = nVal
      }
    }
  },
  created () {
    if (Cookie.get('token')) {
      this.isUserLoggedIn = true
    } else {
      this.isUserLoggedIn = false
    }
  },
  mounted () {
    this.getCategoryData()
    this.getCanvasMtd()
    if (Cookie.get('token')) {
      this.getOrderList()
      this.getUserInfoData()
    }
    this.getClaasifyProducts(this.costumeClassifyId)// 服饰配饰
    this.gethotProductsFunction(4)// 有有特价传4、有有上新传5
    this.gethotProductsFunction(5)
    this.getClaasifyProducts(this.foodClassifyId)// 食品茶酒
    this.getInformation()// 有有资讯
    this.queryShop()//查询店铺
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setUserInfo: 'SET_USERINFO',
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
      setNewAddress: 'SET_NEWADDRESS',
      setAreaCode: 'SET_AREACODE',
      setNoticeId: 'SET_NOTICEID',
      IS_LOGIN: 'IS_LOGIN'
    }),
    toRouter (path) {
      this.$router.push(path)
    },
    loginBtn (type) {
      this.$store.commit('SHOW_LOGIN')
      // this.$router.push({path: '/login', query: {type: type}})
    },
    outLoginBtn () {
      this.outLoginDialog = true
    },
    outLogin () {
      this.outLoginDialog = false
      Cookie.remove('token')
      this.setUserInfo({})
      this.setCartNumber('')
      this.setShoppingCart({})
      this.setNewAddress({})
      this.setAreaCode([])
      this.$router.push({ path: '/index' })
      this.$store.commit('IS_LOGIN', false) // 清除登录状态
      this.isUserLoggedIn = false
    },
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      if (res.code === '200') {
        this.categories = res.data
      }
    },
    // 跳转到类别主页
    jumpCategory (item) {
      this.$router.push({
        name: 'category',
        query: {
          classifyData: JSON.stringify(item)
        }
      })
    },
    // 跳转分销页面
    toMyDistribution () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/myDistribution' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    showSubCategory (category) {
      //   this.activeSecondaryCategory = category.classifyId // 记录当前激活的二级分类
      this.isExpanded = true
      this.currentCategory = category
    },
    // const response = await getCanvas(params)
    async getCanvasMtd () {
      let params = {
        terminal: '4',
        type: '1'
      }
      const response = await getCanvas(params)
      let arr = JSON.parse(response.data.data.json)
      this.bannerList = arr.find(i => i.type === 'banner').componentContent.bannerData
      console.log(this.bannerList)
    },
    // 跳转
    toLiveStreamingRoom (url, classifyId) {
      this.$router.push({
        path: url,
        query: {

          classifyId: JSON.stringify(classifyId)
        }

      })
    },
    // 获取订单列表
    async getOrderList () {
      this.loading = true
      const response = await getOrderList({
        search: '',
        state: '',
        page: 1,
        pageSize: 3
      })
      const res = response.data
      if (res.code === '200') {
        this.shoppingCart = res.data.list
      } else {
        this.$message.warning(res.message)
      }
    },
    // 服饰配饰
    async getClaasifyProducts (id) {
      const response = await getClaasifyProducts({
        classifyId: id,
        type: '',
        volume: '',
        page: '1',
        pageSize: '12'
      })
      const res = response.data
      if (res.code === '200') {
        const list = res.data && Array.isArray(res.data.list) ? res.data.list : []
        if (id === this.costumeClassifyId) {
          this.costumelist = list.slice(0, 2)
        } else if (id === this.foodClassifyId) {
          this.foodList = list.slice(0, 2)
        }
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        })
      }
    },
    // 有有特价
    async gethotProductsFunction (type) {
      const response = await gethotProducts({
        page: '1',
        pageSize: '12',
        search: '',
        type: type,
      })
      const res = response.data

      if (res.code === '200') {
        const list = res.data && Array.isArray(res.data.list) ? res.data.list : []
        if (type === 4) {
          this.specialOfferlist = list.slice(0, 2)
        } else if (type === 5) {
          this.newProductlist = list.slice(0, 4)
        }
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        })
      }
    },
    // 资讯
    async getInformation () {
      const response = await getConsultation({
        consultationId: '',
        title: '',
        page: '1',
        pageSize: '2'
      })
      const res = response.data
      if (res.code === '200') {
        let list = res.data.list
        this.informationList = list
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        })
      }
    },
    handlerImg (item) {
      console.log(item)
      let url = null
      let id = null

      // 跳转分类
      if (item.linkObj.data.id) {
        url = '/foodZone'
        id = item.linkObj.data.id
        this.toLiveStreamingRoom(url, id)
      }
      // 跳转店铺
      if (item.linkObj.data.shopId) {
        id = item.linkObj.data.shopId
        this.toStore(id)
      }
    },
    //查询店铺
    async queryShop () {
      const response = await getIndexShop({
        page:'1',
        pageSize:'3',
      })
      const res = response.data
      if (res.code === '200') {
        this.shopList = res.data.list
        console.log("0",this.shopList)
        
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        })
      }
    },
    // 跳转店铺
    toStore (id) {
      console.log("1",id)
      // if (Cookie.get('token')) {

      // }
      this.$router.push({
          path: '/store', query: { shopId: id }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.home-banner {
  display: flex;
  min-height: 408px;
  height: 350px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
  gap: 16px;
  position: relative;
}

.category-nav {
  width: 248px;
  min-width: 248px;
  background: #f4f8fe;
  padding: 10px;
  overflow: auto;

  .subcategory-panel {
    position: absolute;
    left: 239px;
    top: 16px;
    width: 740px;
    height: 376px;
    overflow: auto;
    border-radius: 6px 6px 6px 6px;
    border: 2px solid #584dff;
    background-color: #ffff;
    z-index: 99999;

    .secondary-category-list {
      padding: 16px;
      display: grid;
      gap: 12px;
    }
  }

  ul {
    list-style: none;
    padding: 0;

    .category-nav_item {
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      transition: background 0.3s;
      display: flex;
      align-items: center;
      gap: 8px;

      &:hover {
        background: linear-gradient(90deg,
            rgba(88, 77, 255, 0.1) 40%,
            /* #584DFF 透明度 50% */
            rgba(24, 102, 237, 0.1) 100%
            /* #1866ED 透明度 20% */
          );
      }

      i {
        margin-right: 8px;
        font-size: 16px;
      }

      span {
        font-size: 14px;
        color: #333;
      }
    }

    .secondary-category-list-title {
      width: 80px;
      min-width: 80px;
    }

    .selectedSpan:hover {
      // display: inline-block;
      background: linear-gradient(7.064707531409216e-7deg,
          #584dff 40%,
          #1866ed 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-decoration: underline;
      // 使用底部边框替代下划线
      border-bottom: 1px solid #584dff;
    }
  }
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.top-banner {
  display: flex;
  gap: 16px;
}

.banner-left {
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  width: 512px;
  height: 193px;
}

.banner-right {
  flex: 1;
  background: #f4f8fe;
  border-radius: 6px;
  padding: 12px 16px;
  width: 512px;
  height: 193px;
}

.sub-banner {
  .Ltitle {
    font-size: 16px;
    color: #181818;
    font-weight: bold;
  }

  .Rtitle {
    font-size: 14px;
    color: #4b5b76;
  }

  .products {
    display: flex;
    gap: 20px;

    .product-item {
      flex: 1;
      text-align: center;
      cursor: pointer;

      img {
        width: 80px;
        height: 80px;
        object-fit: contain;
      }

      .price {
        font-size: 16px;
        font-weight: bold;
        color: #ff3b30;
        display: inline-block;
        line-height: 24px;
        margin-bottom: 0px;
      }

      .discount {
        font-size: 12px;
        color: #ff3333;
      }
    }
  }
}

.user-login {
  text-align: center;
  padding: 24px 16px 20px 16px;
  background: #f4f8fe;
  height: 220px;

  .avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #97a3b7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    font-size: 24px;
    color: #fff;
  }

  .greeting {
    font-size: 16px;
    color: #181818;
    font-weight: bold;
    line-height: 14px;
    margin-bottom: 4px;
  }

  .login-text {
    font-size: 12px;
    color: #97a3b7;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .login-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(7.064707531409216e-7deg,
        #584dff 40%,
        #1866ed 100%);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
}

.recommend-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.live-streaming,
.flash-sale,
.package-deals,
.one-yuan-deals {
  background: #f4f8fe;
  border-radius: 6px;
  padding: 12px 10px;
  height: 168px;
}

.you-you-shi {
  background: #f4f8fe;
  border-radius: 6px;
  padding: 12px 13px;
  height: 140px;
  font-weight: 600;
  color: #181818;
  font-size: 16px;

  ul {
    display: flex;
    justify-content: space-evenly;

    li {
      img {
        width: 75px;
        height: 75px;
        flex-shrink: 0;
      }
    }
  }
}

.live-streaming,
.flash-sale {
  grid-column: span 2;
}

.live-streaming .title,
.flash-sale .title,
.package-deals .title,
.one-yuan-deals .title {
  font-size: 16px;
  color: #181818;
  font-weight: bold;
  line-height: 24px;
}

.live-streaming .subtitle,
.flash-sale .subtitle,
.package-deals .subtitle {
  font-size: 14px;
  line-height: 22px;
  color: #4b5b76;
}

.live-cards {
  display: flex;
  gap: 10px;
  // justify-content: space-between;
}

.live-card {
  flex: 1;
  min-width: 0;
  max-width: 25%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  color: #ff3b30;
  font-weight: 600;

  .price {
    // text-align: center;
  }

  img {

    width: 100px;
    height: 116px;
    object-fit: cover;
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
    margin-bottom: 5px;
  }

  .card-title {
    // position: absolute;
    // bottom: 6px;
    // left: 10px;
    font-size: 15px;
    color: #ff3b30;
    font-weight: 600;
    margin-top: 4px;
  }
}

.sale-items,
.items {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  // padding: 7px 0;
}

.sale-item,
.deal-item {
  // flex: 1;
  width: 50%;
  text-align: center;
  cursor: pointer;
  justify-content: space-between;

  img {
    width: 80px;
    height: 80px;
    // object-fit: contain;
  }

  .price {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #ff3b30;
    text-align: center;
  }
}

.you-you-shi {
  // display: flex;
  // justify-content: space-between;

  .title {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .description {
    font-size: 14px;
    line-height: 24px;
    color: #181818;
    font-weight: bold;
  }

  .description2 {
    font-size: 12px;
    line-height: 20px;
    color: #4b5b76;
    margin-bottom: 8px;
  }
}

.user-center {
  width: 248px;
  height: 376px;
  background-color: rgba(255, 51, 51, 0.04);
  border-radius: 6px;
  padding: 24px 16px;
  position: relative;

  .user-header {}

  .user-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  .user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .user-info {
    display: inline-block;
    vertical-align: middle;
  }

  .user-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
    width: 80px;
    min-width: 80px;
  }

  .user-actions {
    font-size: 12px;
    color: #4b5b76;
    display: flex;
    gap: 4px;
  }

  .ai-badge {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }

  .user-balance {
    padding: 20px 14px 16px 14px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 51, 51, 0.1);
  }

  .balance-item {
    text-align: center;
  }

  .balance-number {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  .balance-label {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }

  .quick-actions {
    padding: 20px 0 16px 0;
    display: flex;
    justify-content: space-between;
  }

  .action-item {
    text-align: center;
    flex: 1;
    cursor: pointer;
  }

  .action-icon {
    width: 24px;
    height: 24px;
    margin: 0 auto 4px;
    fill: #333;
  }

  .action-text {
    font-size: 12px;
    color: #333;
  }

  .order-status {
    padding: 8px;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;

    .order-status_carousel {
      >>>.el-carousel__indicator--horizontal {
        padding: 0 6px !important;

        .el-carousel__button {
          width: 20px;
          height: 3px;
          border-radius: 3px;
        }
      }

      >>>.el-carousel__indicator button {
        background-color: #97a3b7;
        width: 20px;
      }

      >>>.el-carousel__indicator.is-active {
        button {
          background-color: #584dff;
        }
      }
    }
  }

  .order-item {
    display: flex;
    align-items: center;
  }

  .order-item:last-child {
    border-bottom: none;
  }

  .order-image {
    width: 45px;
    height: 45px;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 12px;
  }

  .order-image img {
    width: 45px;
    height: 45px;
    border-radius: 4px;
    overflow: hidden;
    object-fit: cover;
  }

  .order-content {
    flex: 1;
  }

  .order-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
  }

  .order-desc {
    font-size: 12px;
    color: #999;
  }

  .footer-links {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #181818;
  }

  .footer-link {
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
  }

  .footer-link img {
    width: 14px;
    height: 14px;
  }
}

.information {
  ol {
    align-content: space-between;

    li {
      align-items: center;
      line-height: 1.5;

      .informationImg {
        width: 90px;
        height: 50px;
        object-fit: cover;
        flex-shrink: 0;
        display: block;
      }

      span {
        color: #4B5B76;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeBanner.vue